import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';

export default function isUnsupportedDateRangeTypeForSplitView(): boolean {
    return getSurfaceStore().dateRangeType === DateRangeType.Month;
}
